import React from "react";
import { Dropdown } from "react-bootstrap";
import { Settings } from "react-feather";
import { LinkContainer } from "react-router-bootstrap";

import useAuth from "../../hooks/useAuth";

const NavbarUser = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <Dropdown className="nav-item" align="end">
      <span className="d-inline-block d-sm-none">
        <Dropdown.Toggle as="a" className="nav-link">
          <span className="text-dark">{user.email}</span>&nbsp;
          <Settings size={18} className="align-middle" />
        </Dropdown.Toggle>
      </span>
      <span className="d-none d-sm-inline-block">
        <Dropdown.Toggle as="a" className="nav-link">
          <span className="text-dark">{user.email}</span>
        </Dropdown.Toggle>
      </span>
      <Dropdown.Menu variant="light">
        <LinkContainer to="/settings">
          <Dropdown.Item>Nastavitve</Dropdown.Item>
        </LinkContainer>
        {/*<Dropdown.Item>Help</Dropdown.Item>*/}
        <Dropdown.Item href="/auth/sign-out">Odjava</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarUser;
